// services/sellos.js
import api from "services/api";

const ENDPOINT = "/recordLabel";

// ⬇️ NUEVO: listSellos con params y salida normalizada
export async function listSellos(params = null) {
  const { data } = await api.get(ENDPOINT, params ? { params } : undefined);

  // Normaliza filas
  const rows =
    Array.isArray(data?.page)    ? data.page :
    Array.isArray(data?.rows)    ? data.rows :
    Array.isArray(data?.data)    ? data.data :
    Array.isArray(data?.results) ? data.results :
    Array.isArray(data)          ? data :
    [];

  // Normaliza total
  const total =
    typeof data?.total === "number" ? data.total :
    typeof data?.count === "number" ? data.count :
    (Array.isArray(data?.page) || Array.isArray(data?.rows) || Array.isArray(data?.data) || Array.isArray(data))
      ? rows.length
      : 0;

  return { total, rows };
}

export async function getSelloById(id) {
  const { data } = await api.get(`${ENDPOINT}/${id}`);
  return data?.data ?? data ?? {};
}

export async function createSello(payload) {
  const { data } = await api.post(ENDPOINT, payload);
  return data?.data ?? data;
}

export async function updateSello(id, payload) {
  const url = `${ENDPOINT}/${encodeURIComponent(id)}`;
  const { data } = await api.put(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function deleteSello(id) {
  const url = `${ENDPOINT}/${encodeURIComponent(id)}`;
  const { data } = await api.delete(url);
  return data?.data ?? data;
}
